import { render, staticRenderFns } from "./ModalHeaderWrapper.vue?vue&type=template&id=a69148fa&"
import script from "./ModalHeaderWrapper.vue?vue&type=script&lang=js&"
export * from "./ModalHeaderWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports